import React from 'react';
var RendererContext = /*#__PURE__*/React.createContext({});
export var useRendererContext = function useRendererContext() {
  return React.useContext(RendererContext);
};
export var RendererContextProvider = RendererContext.Provider;